import { render } from "./ShopDetailMenu.vue?vue&type=template&id=61438f06"
import script from "./ShopDetailMenu.vue?vue&type=script&lang=js"
export * from "./ShopDetailMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__